import React from "react";
import styles from "../../../assets/stylesheets/blog/FarmmodeBlogDetail.module.css";
import MainImg from "../../../assets/img/blog/maple/MainMaple.webp"; 

import Elmira from "../../../assets/img/blog/maple/Elmira.webp"; 
import Joseph from "../../../assets/img/blog/maple/Joseph.webp"; 
import Kawarthas from "../../../assets/img/blog/maple/Kawarthas.webp"; 
import Muskoka from "../../../assets/img/blog/maple/Muskoka.webp"; 
import Purple from "../../../assets/img/blog/maple/Purple.webp"; 

const MAPLE_SECTIONS = [
  {
    farms: [
      {
        name: "Warkworth Maple Syrup Festival 2025",
        img: null,
        subTitle: "Celebrating 37 Sweet Years of Tradition!",
        description: "Since 1988, Warkworth has welcomed families to experience the magic of maple syrup, community spirit, and endless fun in the beautiful village and Sandy Flat Sugar Bush!",
        location: "Warkworth, Ontario",
        website: "Warkworth Maple Syrup Festival",
        webUrl: "https://warkworthmaplesyrupfestival.ca/",
        details: [
          { label: "Dates", value: "March 8-9, 2025 (Saturday & Sunday)" },
          { label: "FREE Parking & Shuttle Buses", value: "From Warkworth Village to Sandy Flat Sugar Bush: 8:30 AM - 3PM" },
          { label: "Festival Highlight", value: "Pancake Breakfast – Enjoy pancakes, sausages, and Warkworth’s famous maple syrup! | Sugar Bush Tours – Learn how maple syrup is made with sap-making demonstrations! | Horse-Drawn Sleigh Rides – Take a scenic ride through the sugar bush! | Maple Taffy on Snow – Sweet treats made fresh on the snow! | Live Entertainment – Music from SweetGrass Band & more! | Maplelicious in the Village – Explore shops, artisan markets, and maple-themed goodies! | Beer Garden – Enjoy local brews from Fogorig Brewery. | Art Exhibits & Activities – Check out local art at AH! Centre, mini-golf, axe throwing, and more!" }
        ]
      },
      {
        name: "Purple Woods Maple Syrup Festival 2025",
        img: Purple, 
        subTitle: "Step into a Canadian Tradition!",
        description: "Celebrate maple season at Purple Woods Conservation Area, where you can see maple syrup being made, take a self-guided sugarbush hike, and enjoy fresh pancakes with real maple syrup!",
        location: "Purple Woods Conservation Area, 38 Coates Road East, Oshawa",
        website: "Purple Woods Maple Syrup Festival",
        webUrl: "https://www.cloca.com/purple-woods-maple-syrup-festival",
        details: [
          { label: "Dates", value: "March 12-14, 2025" },
          { label: "Time", value: "9:30 AM - 12:00 PM | 12:00 PM - 2:30 PM" },
          { label: "Tickets", value: "Required (Choose morning or afternoon slot)" },
          { label: "Festival Highlight", value: "Maple Syrup Demonstrations – See sap turn into syrup! | Horse-Drawn Wagon Rides (Select dates) | Self-Guided Sugarbush Hikes | Sweet Shack Taffy Treats ($2 cash only) | Heritage Store – Buy fresh maple syrup & local treats! | Plan Ahead! Tickets must be purchased in advance – limited spots per session!" }
        ]
      },
      {
        name: "York Region Maple Syrup Festival 2025",
        img: null, 
        subTitle: "Experience Ontario’s Sweetest Season!",
        description: "Celebrate spring & maple syrup season with family-friendly fun, outdoor activities, and hands-on maple syrup demonstrations at two amazing locations!",
        location: "Bruce’s Mill Conservation Area (3291 Stouffville Road, Whitchurch-Stouffville) & Kortright Centre for Conservation (9550 Pine Valley Drive, Woodbridge)",
        website: "York Region’s Maple Syrup Festival",
        webUrl: "https://maplesyrupfest.com/",
        details: [
          { label: "Dates", value: "March 8 – April 6, 2025" },
          { label: "Admission", value: "Required (Pre-purchase tickets online!)" },
          { label: "Festival Highlight", value: "Maple Syrup Demonstrations & Tastings | Wagon Rides (Kortright) | Live Entertainment & Family Activities | Treewalk Village & Outdoor Adventures (Bruce’s Mill, additional fees) | Evening Maple Syrup Experience (Kortright – Fridays & Saturdays at 6:30 PM)" }
        ]
      },
      {
        name: "Elmira Maple Syrup Festival 2025",
        img: Elmira, 
        subTitle: "Canada’s Largest One-Day Maple Festival!",
        description: "Since 1965, Elmira has been celebrating Ontario’s liquid gold with pancakes, fresh maple syrup, and endless family fun!",
        location: "Downtown Elmira, Ontario",
        website: "Elmira Maple Syrup Festival",
        webUrl: "https://www.elmiramaplesyrupfestival.com/",
        details: [
          { label: "Dates", value: "April 5, 2025 (Saturday)" },
          { label: "Admission", value: "FREE Admission & Parking" },
          { label: "Festival Highlight", value: "Pancake Breakfast – Served with fresh maple syrup! | Sugar Bush Tours – See how maple syrup is made! | Family Fun Area – Pony rides, inflatables & climbing wall | Live Entertainment – Music & performances all day! | Local Vendors & Craft Market – Handmade goods & treats | Scenic Train Ride Option – Take the Waterloo Central Railway to the festival!" }
        ]
      },
      {
        name: "St. Joseph Island Maple Syrup Festival 2025",
        img: Joseph, 
        subTitle: "56 Years of Sweet Tradition!",
        description: "Get ready for ALL-YOU-CAN-EAT PANCAKES, golden local maple syrup, and perfectly fried sausages! A must-visit spring tradition on St. Joseph Island! Come hungry & enjoy a warm, welcoming atmosphere with family & friends.",
        location: "The Royal Canadian Legion Branch 374, 1534 10th Sideroad, Richards Landing, Ontario",
        website: "St. Joseph Island Maple Syrup Festival",
        webUrl: "https://www.stjosephislandhost.com/maple-syrup-festival",
        details: [
          { label: "Dates", value: "April 5-6 & April 12-13, 2025 (8:00 AM – 3:00 PM)" },
          { label: "Contact", value: "705-246-2494" },
          { label: "Festival Highlight", value: "Unlimited Pancakes & Sausages – Drizzled with pure maple syrup! | Maple Syrup Displays & Local Vendors | Raffles & Family-Friendly Fun" }
        ]
      },
      {
        name: "Sunderland Maple Festival 2025",
        img: null, 
        subTitle: "A Sweet Outdoor Celebration!",
        description: "Join the Sunderland Maple Festival for a weekend filled with music, entertainment, and all things maple!",
        location: "1 River Street, Sunderland, Ontario",
        website: "Sunderland Maple Festival",
        webUrl: "https://www.sunderlandmaple.com/",
        details: [
          { label: "Dates", value: "April 5 & 6, 2025" },
          { label: "Admission", value: "FREE Admission & Parking" },
          { label: "Festival Highlight", value: "Pancake Breakfast – Start your day the maple way! | Local Maple Producers & Vendors – Taste & shop fresh maple treats | Live Music & Entertainment – Fun for the whole family! | Iron Forging Demonstrations – See blacksmithing in action! | Festival Recipes – Try Maple Garlic Chicken Wings & Maple Butter Tarts" },
          { label: "Bonus Maple Treats Nearby!", value: "Spirit Tree Estate Cidery (Caledon) – Maple Bacon Pizza & Maple Butter Tarts | Crave Doughnuts (Whitby) – Maple Glaze & Candied Bacon Doughnuts" }
        ]
      },
      {
        name: "Kawarthas Northumberland Maple Festival 2025",
        img: Kawarthas, 
        subTitle: "Explore the Sweetest Maple Experiences!",
        description: "Kawarthas Northumberland transforms into a maple lover’s paradise every spring! From tree tapping at Elmhirst’s Resort to Maplefest at McLean Berry Farm, build your perfect maple-themed getaway.",
        location: "Throughout Kawarthas & Northumberland",
        website: "Kawarthas Northumberland Maple Festival",
        webUrl: "https://www.kawarthasnorthumberland.ca/",
        details: [
          { label: "Dates", value: "April 5 & 6, 2025" },
          { label: "Festival Highlight", value: "Sugar Bush Tours & Maple Syrup Tastings | Tree Tapping & Evaporator Demonstrations | Horse-Drawn Sleigh Rides (Select locations) | Maple-Inspired Dining & Sweet Treats | Interactive Maple Route – Plan your own journey!" },
          { label: "Seasonal Events", value: "Sandy Flat Sugar Bush (Warkworth) – Wood-fired maple syrup & treats | Red Mill Maple Syrup – Maple Tasting Bar & Bourbon Barrel-Aged Syrup | The Roost Farm – Wagon rides & traditional maple syrup production" }
        ]
      },
      {
        name: "Muskoka Maple Festival 2025",
        img: Muskoka, 
        subTitle: "Ontario’s Sweetest Spring Party!",
        description: "Come hungry, stay entertained, and celebrate the taste of spring in the heart of Muskoka! Get ready for a full day of maple madness in Muskoka!",
        location: "Main Street, Downtown Huntsville, Ontario",
        website: "Muskoka Maple Festival",
        webUrl: "https://www.muskokamaple.ca/",
        details: [
          { label: "Dates", value: "April 26, 2025 (Saturday)" },
          { label: "Admission", value: "FREE ENTRY – No tickets needed!" },
          { label: "Festival Highlight", value: "Pure, Local Maple Syrup & Treats | Pancake Breakfast – Start the day right! | Live Music & Street Performers | Interactive Activities & Family Fun | Maple Taffy on Snow – A Canadian Classic!" }
        ]
      }
    ]
  },

];

export default function MapleSyrup() {
  return (
    <div className={styles.page}>

      {/* Top meta like blogTO */}
      <div className={styles["top-meta"]}>
        {/* <span className={styles["category-name"]}>Event</span>
        <span className={styles["sep"]}>•</span>
        <span>FarmCiti Team</span>
        <span className={styles["sep"]}>•</span>
        <span>February 11, 2025</span> */}
      </div>

      {/* Main Title */}
      <h1 className={styles["title"]}>Canada’s Favorite Celebration! Maple Syrup Festival in Ontario 2025</h1>

      {/* Hero Image */}
      <div className={styles["hero-wrap"]}>
        <img
          className={styles["hero"]}
          src={MainImg}
          alt="Maple Syrup Hero"
        />
      </div>

      <div className={styles["lead-section"]}>
        <p><strong>Experience the taste of spring at Ontario’s finest maple syrup farms and festivals.</strong><br/>
        As winter fades and spring approaches, warmer days and chilly nights set the stage for sap to rise in sugar maple trees, marking the start of maple syrup season.</p>
        <p>For a brief but beloved time, families head to sugar bushes and sugar shacks to see the magic of sap turning into syrup. Pancake breakfasts are served, kids enjoy maple taffy, and maple-themed festivals pop up everywhere.</p>
        <p>But maple syrup isn’t just for pancakes. It flavors everything from beer and wine to teas, jams, butter tarts, donuts, and even bacon.</p>
        <p>Beyond maple, birch trees are tapped later in the season, producing birch syrup—less sweet but perfect for savory dishes like marinades and BBQ sauces.</p>
        <p>Celebrate this sweet season during Ontario Maple Weekend in early April, with sugarbushes across the province offering fun activities. Don’t miss out—this delicious season is short but unforgettable!</p>
      </div>

      {MAPLE_SECTIONS.map((section, idx) => (
        <div key={idx}>
          <hr className={styles["region-divider"]} />
          
          {section.farms.map((farm, fIdx) => (
            <div key={fIdx} className={styles["farm-section"]}>
              <h3 className={styles["farm-name"]}>{farm.name}</h3>
              <hr className={styles["region-divider"]} />
              
              {farm.img && <img src={farm.img} alt={farm.name} className={styles["farm-image"]} />}
              
              <div className={styles["farm-description"]}>
                <p><strong>{farm.subTitle}</strong></p>
                <p>{farm.description}</p>
              </div>

              <div className={styles["event-details-title"]}>Event Details:</div>
              <ul className={styles["details-list"]}>
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Location:</span> {farm.location}
                </li>
                {farm.website && (
                    <li className={styles["details-item"]}>
                    <span className={styles["details-label"]}>Website:</span><br />
                    <a href={farm.webUrl} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                        {farm.website}
                    </a>
                    </li>
                )}
                {farm.details && farm.details.map((detail, dIdx) => {
                  const isHighlight = ["Festival Highlight", "Bonus Maple Treats Nearby!", "Seasonal Events"].includes(detail.label);
                  if (isHighlight) {
                    let contentItems = [];
                    if (detail.value.includes('|')) {
                      contentItems = detail.value.split('|').map(s => s.trim());
                    } else {
                      contentItems = [detail.value];
                    }

                    return (
                      <li key={dIdx} className={styles["highlight-detail"]}>
                        <span className={styles["highlight-label"]}>{detail.label}</span>
                        <div className={styles["highlight-content"]}>
                          <ul className={styles["highlight-list"]}>
                            {contentItems.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </li>
                    );
                  }
                  return (
                    <li key={dIdx} className={styles["details-item"]}>
                      <span className={styles["details-label"]}>{detail.label}:</span> {detail.value}
                    </li>
                  );
                })}
              </ul>
              <hr className={styles["farm-divider"]} />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
